import { render, staticRenderFns } from "./VacanciesLast5YearsBlock.vue?vue&type=template&id=0f2f5cb4&scoped=true&"
import script from "./VacanciesLast5YearsBlock.vue?vue&type=script&lang=js&"
export * from "./VacanciesLast5YearsBlock.vue?vue&type=script&lang=js&"
import style0 from "./VacanciesLast5YearsBlock.vue?vue&type=style&index=0&id=0f2f5cb4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2f5cb4",
  null
  
)

export default component.exports